import { LanguagesConstants } from '../constants';
import { CounsellorsService } from '../../services/';


export const LanguagesActions = {
	fetchLanguages,
		
};

function fetchLanguages() {
	return (dispatch) => {
		dispatch(request());

		CounsellorsService.fetchLanguages().then(
			(languages) => {
				dispatch(success(languages));
			},
			(error) => dispatch(failure(error.toString()))
		);
	};
}

function request() {
	return { type: LanguagesConstants.GET_LANGUAGES_REQUEST };
}

function success(data) {
	//if (data) {
		return { type: LanguagesConstants.GET_LANGUAGES_SUCCESS, data };
    // }
}

function failure(error) {
	return { type: LanguagesConstants.GET_LANGUAGES_FAILURE, error };
}



// WEBPACK FOOTER //
// ./src/store/actions/languages.actions.js